import { GqlRequestOptions } from '@common/api-request';

import { getMetaFeatureList } from '../graphql/meta-feature-list.2';

export const META_FEATURE_QUERY_KEY = 'getMetaFeature';

export interface GetMetaFeatureParams {
  uuid: string;
}

export function MetaFeatureQueryOption({ uuid }: GetMetaFeatureParams, options?: GqlRequestOptions) {
  return {
    queryKey: [META_FEATURE_QUERY_KEY],
    queryFn: async function () {
      const { data } = await getMetaFeatureList(
        {
          data_version: 7,
          platfrom: '',
          ui: uuid?.split('.')[0],
        },
        { ...options, show_alert: false },
      );
      return data.metadata.feature_list;
    },
  };
}

export async function requestMetaFeatureList({ uuid }: GetMetaFeatureParams, options?: GqlRequestOptions) {
  try {
    const { data } = await getMetaFeatureList(
      {
        data_version: 7,
        platfrom: '',
        ui: uuid?.split('.')[0],
      },
      { ...options, show_alert: false },
    );
    return data.metadata.feature_list;
  } catch (e) {
    console.error(e);
  }
}
